import type { ReactNode } from "react";

export interface JerryNoteProps {
  /** Texto del hallazgo de Jerry; admite `<strong>` para la cifra. */
  children: ReactNode;
  /** Acción de contorno a la derecha (p. ej. "Ver detalle"). */
  action?: { label: string; onClick?(): void };
  /** Contenido extra a la derecha de la acción. */
  trailing?: ReactNode;
  /** Nombre accesible de la franja. */
  ariaLabel: string;
}

/** Franja lila de una línea con un dato de Jerry y una acción opcional. */
export function JerryNote({ children, action, trailing, ariaLabel }: JerryNoteProps) {
  return (
    <section aria-label={ariaLabel} className="flex items-center gap-3 rounded-[var(--ds-radius-lg)] bg-[var(--ds-card-lilac)] px-4 py-3 text-[var(--ds-on-card)]">
      <span aria-hidden="true" className="flex size-9 flex-none items-center justify-center rounded-full bg-[var(--ds-on-card)]">
        <img src="/brand/jerry-face-mark-crema.svg" alt="" className="h-3.5 w-auto" />
      </span>
      <p className="m-0 min-w-0 flex-1 text-[15px] leading-[22px]">{children}</p>
      {action ? (
        <button
          type="button"
          onClick={action.onClick}
          className="app-focus-ring ml-auto inline-flex min-h-11 flex-none items-center justify-center rounded-full border-[1.5px] border-solid border-[var(--ds-on-card)] bg-transparent px-4 text-sm font-medium leading-none text-[var(--ds-on-card)] whitespace-nowrap md:min-h-9"
        >
          {action.label}
        </button>
      ) : null}
      {trailing}
    </section>
  );
}
